export const userEnums = Object.freeze({
  userContext: {
    MYEMPLOYEES: 1,
    ADMIN: 2
  }
});
